import React, { useState } from "react";
import TimeRangePicker from "@wojtekmaj/react-timerange-picker";
import { Clock } from "phosphor-react";
import "@wojtekmaj/react-timerange-picker/dist/TimeRangePicker.css";
import "react-clock/dist/Clock.css";
import "./TimeRangeInput.scss"; // Create and import your custom SCSS file
function TimeRangeInput({
  name,
  value,
  handleChange,
  placeholder = "Select time range",
  label = "Time Range",
  isRequired = false,
  isError = false,
  error = "",
  disabled = false,
}) {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={`input-otr ${disabled ? "disabled-input" : ""}`}>
      <label htmlFor={name} className="input-label">
        {label} {isRequired && <span style={{ color: "red" }}>*</span>}
      </label>
      <div className="position-relative w-100">
        <TimeRangePicker
          onChange={handleChange}
          value={value}
          //   disableClock
          format="HH:mm"
          className={`theme-input input w-100 z-1 ${
            isError ? "border-danger" : ""
          } ${isActive ? "border-active" : ""}`}
          disabled={disabled}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          clearIcon={null}
          clockIcon={null}
          rangeDivider="/"
          hourPlaceholder="hh"
          minutePlaceholder="mm"
        />
        <span className="position-absolute top-50 end-0 translate-middle p-1 pe-0 z-3 cursor-pointer">
          <Clock size={30} weight="bold" color="#60606090" />
        </span>
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default TimeRangeInput;
